import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import LayoutWithMap from 'containers/Base/LayoutWithMap';

import {
  tripTypeSelectors,
  tripTypeGridActions,
  tripTypeNS,
  tripTypeFilterActions,
} from 'containers/Pages/Tasks/TripTypes';
import { useDispatch, useSelector } from 'react-redux';
import { modalState, toggleModal } from 'reducers/ui';
import useFilters from 'containers/Base/useFilters';

const TripTypes = ({ columns, FormComponent, editable, loading, details }) => {
  const filterValues = useSelector(state =>
    tripTypeSelectors.getFilters(state),
  );
  const tripTypeListData = useSelector(state =>
    tripTypeSelectors.getTripTypeListTransformed(state),
  );
  const totalEntries = useSelector(state =>
    tripTypeSelectors.getTotalEntries(state),
  );

  const forceRefresh = useSelector(state =>
    tripTypeSelectors.getForceRefresh(state),
  );
  const modalOpen = useSelector(state => modalState(state));
  //--------------------------customHooks--------------------------
  const { localFilterValues, updateFilter } = useFilters({
    filterValues,
  });
  //---------------------------Actions------------------------------
  const dispatch = useDispatch();
  const dispatchFetchTripTypeAction = useCallback(
    ({ filters, from }) =>
      dispatch(
        tripTypeGridActions.fetchGridList({
          filters,
          from,
        }),
      ),
    [dispatch],
  );
  const onUpdate = filters => {
    dispatchFetchTripTypeAction({
      filters,
    });
  };
  //----------------------------------------------------------------

  const fetchTripTypes = from => {
    dispatchFetchTripTypeAction({
      filters: localFilterValues,
      from,
    });
  };
  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(tripTypeNS)),
    [dispatch],
  );

  return (
    <LayoutWithMap
      header="Trip Types"
      cols={columns}
      toggleModal={dispatchToggleModal}
      data={tripTypeListData}
      totalEntries={totalEntries}
      loading={loading}
      forceRefresh={forceRefresh}
      //creating and editing
      filtersRequired={true}
      filterValues={localFilterValues}
      filters={{
        RegularFilters: [
          {
            label: 'Archived',
            field: 'archived',
            type: 'toggle',
          },
        ],
      }}
      setFilters={(values, hasApplyFilter) =>
        updateFilter({
          values,
          hasApplyFilter,
          applyFilter: filters => {
            dispatch(tripTypeFilterActions.setFilterKey(true));
            dispatch(tripTypeFilterActions.setFilters(filters));
          },
        })
      }
      showSearchFilter={false}
      onUpdate={onUpdate}
      editable={editable}
      fetchData={fetchTripTypes}
      //setGridAPI={gridAPIHandler}
      //Form
      FormComponent={FormComponent}
      DetailComponent={details}
      onEdit={modalOpen[tripTypeNS]}
    />
  );
};
TripTypes.propTypes = {
  columns: PropTypes.array.isRequired,
  details: PropTypes.func.isRequired,
  editable: PropTypes.bool.isRequired,
  filtersRequired: PropTypes.bool,
  loading: PropTypes.bool,
  FormComponent: PropTypes.elementType,
};

export default TripTypes;
